import { applyMiddleware, compose, createStore } from "redux";

import createSagaMiddleware from "redux-saga";
import { createMigrate, persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { createBrowserHistory } from "history";
import { routerMiddleware } from "connected-react-router";

import reducers from "../reducers";
import rootSaga from "../sagas";

const history = createBrowserHistory();
const routeMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

const migrations = {
    7: state => {
        return {
            ...state
        };
    }
};

const persistConfig = {
    key: "azapfyRoot",
    storage,
    version: 7,
    whitelist: ["settings"],
    migrate: createMigrate(migrations, { debug: false })
};

const middlewares = [sagaMiddleware, routeMiddleware];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(initialState) {
    const persistedReducer = persistReducer(persistConfig, reducers(history));
    const store = createStore(
        persistedReducer,
        initialState,
        composeEnhancers(applyMiddleware(...middlewares))
    );
    const persistor = persistStore(store);

    sagaMiddleware.run(rootSaga);

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept("../reducers", () => {
            const nextRootReducer = require("../reducers");
            store.replaceReducer(
                persistReducer(persistConfig, nextRootReducer)
            );
        });
    }

    return { store, persistor };
}

export { history };
